var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('webflow-integration-form',{attrs:{"contentplan-id":_vm.contentplanId,"workspace-id":_vm.workspaceId,"show-header":true,"show-help":true,"allow-delete":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }